import { Aperture } from 'lucide-react'
import { LENSES, type Lens } from '@/domain/lens'

/** Segmented picker for the mounted lens. The choice persists via App. */
export function LensPicker({ lens, onChange }: { lens: Lens; onChange: (l: Lens) => void }) {
  return (
    <div className="flex items-center gap-2">
      <Aperture size={13} className="shrink-0 text-muted" aria-hidden="true" />
      <div role="radiogroup" aria-label="Mounted lens" className="flex gap-1">
        {LENSES.map((l) => (
          <button
            key={l.id}
            role="radio"
            aria-checked={lens.id === l.id}
            onClick={() => onChange(l)}
            title={l.name}
            className={`rounded-md px-2 py-1 text-[11px] font-semibold transition-colors ${
              lens.id === l.id
                ? 'bg-chrome text-ink'
                : 'bg-panel text-muted hover:bg-edge hover:text-chrome'
            }`}
          >
            {l.shortName}
          </button>
        ))}
      </div>
    </div>
  )
}
